import * as yup from "yup";

const TIPOS_COM_RAMO_ATIVIDADE = [
    "Edificações individuais", "Ligação provisória", "Loteamentos",
    "Entrada primária ( MT / AT)", "Alteração de carga (BT / MT / AT)",
    "Aumento de potência disponibilizada", "Ligação nova com ramal de profundidade",
    "Outros", "Medições agrupadas", "Edificações com múltiplas UCs"
];
const TIPOS_COM_LOTEAMENTO = ["Loteamentos"];
const TIPOS_COM_QUANTIDADE_MEDIDORES = ["Medições agrupadas", "Edificações com múltiplas UCs"];
const TIPOS_COM_CARGA_INSTALADA_E_A_INSTALAR = [
    "Edificações individuais", "Entrada primária ( MT / AT)", "Alteração de carga (BT / MT / AT)",
    "Aumento de potência disponibilizada", "Ligação nova com ramal de profundidade",
    "Medições agrupadas", "Edificações com múltiplas UCs"
];
const TIPOS_COM_PRAZO_LIGACAO_DEFINITIVA = [
    "Edificações individuais", "Entrada primária ( MT / AT)", "Alteração de carga (BT / MT / AT)",
    "Aumento de potência disponibilizada", "Ligação nova com ramal de profundidade", "Loteamentos",
    "Iluminação pública (caso construção de rede)", "Medições agrupadas", "Edificações com múltiplas UCs"
];
const TIPOS_COM_AUMENTO_E_PERTURBADORA = [
    "Edificações individuais", "Entrada primária ( MT / AT)", "Alteração de carga (BT / MT / AT)",
    "Aumento de potência disponibilizada", "Ligação nova com ramal de profundidade",
    "Medições agrupadas", "Edificações com múltiplas UCs"
];

const numeroNullable = () =>
    yup
        .number()
        .transform((value, originalValue) => {
            if (
                originalValue === "" ||
                originalValue === null ||
                originalValue === undefined
            ) {
                return null;
            }

            return isNaN(value) ? null : value;
        })
        .nullable()
        .typeError("Informe um número válido");

const schema = yup.object().shape({
    CodigoConsultaPrevia: yup
        .object()
        .nullable()
        .required("Campo obrigatório"),

    TipoInscricao: yup
        .object()
        .nullable()
        .required("Campo obrigatório"),

    Inscricao: yup
        .string()
        .required("Campo obrigatório"),

    Nome: yup
        .string()
        .required("Campo obrigatório"),

    Email: yup
        .string()
        .email("E-mail inválido")
        .required("Campo obrigatório"),

    DemandaCalculada: numeroNullable()
        .required("Campo obrigatório"),

    RamoAtividade: yup
        .string()
        .when("NomeTipoProjeto", {
            is: (nome) => TIPOS_COM_RAMO_ATIVIDADE.includes(nome),
            then: yup.string().required("Campo obrigatório"),
            otherwise: yup.string().notRequired().nullable(),
        }),

    NomeLoteamento: yup
        .string()
        .when("NomeTipoProjeto", {
            is: (nome) => TIPOS_COM_LOTEAMENTO.includes(nome),
            then: yup.string().required("Campo obrigatório"),
            otherwise: yup.string().notRequired().nullable(),
        }),

    QuantidadeLotes: numeroNullable()
        .when("NomeTipoProjeto", {
            is: (nome) => TIPOS_COM_LOTEAMENTO.includes(nome),
            then: (schema) => schema.required("Campo obrigatório"),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    QuantidadeMedidoresUC: numeroNullable()
        .when("NomeTipoProjeto", {
            is: (nome) => TIPOS_COM_QUANTIDADE_MEDIDORES.includes(nome),
            then: (schema) => schema.required("Campo obrigatório"),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    CargaInstaladaExistente: numeroNullable()
        .when("NomeTipoProjeto", {
            is: (nome) => TIPOS_COM_CARGA_INSTALADA_E_A_INSTALAR.includes(nome),
            then: (schema) => schema.required("Campo obrigatório"),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    CargaAInstalar: numeroNullable()
        .when("NomeTipoProjeto", {
            is: (nome) => TIPOS_COM_CARGA_INSTALADA_E_A_INSTALAR.includes(nome),
            then: (schema) => schema.required("Campo obrigatório"),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    PrazoLigacaoDefinitiva: numeroNullable()
        .when("NomeTipoProjeto", {
            is: (nome) => TIPOS_COM_PRAZO_LIGACAO_DEFINITIVA.includes(nome),
            then: (schema) => schema.required("Campo obrigatório"),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    AumentoCarga: yup.boolean().default(false),

    CargaPerturbadora: yup.boolean().default(false),

    DescricaoCargaPerturbadora: yup
        .string()
        .when("CargaPerturbadora", {
            is: true,
            then: (schema) => schema.required("Campo obrigatório"),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    Endereco: yup
        .string()
        .required("Campo obrigatório"),

    Cep: yup
        .string()
        .required("Campo obrigatório"),

    Cidade: yup
        .string()
        .required("Campo obrigatório"),

    Rua: yup
        .string()
        .required("Campo obrigatório"),

    NumeroEnd: numeroNullable()
        .required("Campo obrigatório"),

    UF: yup
        .object()
        .nullable()
        .required("Campo obrigatório"),

    Longitude: numeroNullable(),

    Latitude: numeroNullable(),

    CodigoUc: yup
        .mixed()
        .nullable()
        .when("NovaUC", {
            is: false,
            then: yup
                .number()
                .transform((value, originalValue) => {
                    if (
                        originalValue === "" ||
                        originalValue === null ||
                        originalValue === undefined
                    ) {
                        return null;
                    }

                    return isNaN(value) ? null : value;
                })
                .nullable()
                .typeError("Informe um número válido")
                .required("Campo obrigatório")
                .lessThan(
                    1000000000000,
                    "O valor informado é muito extenso"
                ),

            otherwise: yup
                .mixed()
                .notRequired()
                .nullable(),
        }),
});

const defaultValues = {
    Id: 0,

    CodigoConsultaPrevia: null,

    CodigoResponsavelTecnico: null,

    CodigoUc: "",
    NovaUC: false,

    TipoInscricao: {
        value: 1,
        label: "CPF"
    },

    Inscricao: " ",
    Nome: " ",
    Email: " ",

    TelefoneCelular: " ",
    TelefoneAlternativo: " ",

    NomeTipoProjeto: null,

    DemandaCalculada: null,
    RamoAtividade: " ",
    NomeLoteamento: " ",
    QuantidadeLotes: null,
    QuantidadeMedidoresUC: null,
    CargaInstaladaExistente: null,
    CargaAInstalar: null,
    PrazoLigacaoDefinitiva: null,
    AumentoCarga: false,
    CargaPerturbadora: false,
    DescricaoCargaPerturbadora: " ",

    Endereco: " ",
    Cep: " ",

    CodigoCidade: null,
    Cidade: " ",

    Rua: " ",
    NumeroEnd: null,

    Complemento: " ",

    UF: { value: " ", label: "" },

    Longitude: null,
    Latitude: null,
    DesejaOrcamentoEstimado: false,
};

const camposPorAba = {
    0: [
        "CodigoConsultaPrevia",
        "CodigoUc",
        "TipoInscricao",
        "Inscricao",
        "Nome",
        "Email",
    ],

    1: [
        "Endereco",
        "Cep",
        "Cidade",
        "UF",
        "Rua",
        "NumeroEnd"
    ],

    2: [
        "DemandaCalculada",
        "RamoAtividade",
        "NomeLoteamento",
        "QuantidadeLotes",
        "QuantidadeMedidoresUC",
        "CargaInstaladaExistente",
        "CargaAInstalar",
        "PrazoLigacaoDefinitiva",
        "AumentoCarga",
        "CargaPerturbadora",
        "DescricaoCargaPerturbadora"
    ]
};

export {
    defaultValues,
    schema,
    camposPorAba,
    TIPOS_COM_RAMO_ATIVIDADE,
    TIPOS_COM_LOTEAMENTO,
    TIPOS_COM_QUANTIDADE_MEDIDORES,
    TIPOS_COM_CARGA_INSTALADA_E_A_INSTALAR,
    TIPOS_COM_PRAZO_LIGACAO_DEFINITIVA,
    TIPOS_COM_AUMENTO_E_PERTURBADORA
};